import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './context/AuthContext';
import { BrowserRouter } from 'react-router-dom';
import { LookupProvider } from './context/LookupContext';
import { ThemeProvider } from './context/ThemeContext';
import { AppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from './appInsights';
import './index.css';
import App from './App';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
      <React.StrictMode>
          <AppInsightsContext.Provider value={reactPlugin}>
            <ThemeProvider>
              <AuthProvider>
                <LookupProvider>
                    <BrowserRouter>
                        <App />
                    </BrowserRouter>
                </LookupProvider>
              </AuthProvider>
            </ThemeProvider>
          </AppInsightsContext.Provider>
      </React.StrictMode>
);
